import {useCallback, useEffect, useState} from 'react';

import './styles.scss';
import {Icon, IconSize, Loader} from 'components';
import {screenUtils} from 'utils';

export const WaitingAgentResponse: React.FC = () => {
    const [iconSize, setIconSize] = useState<IconSize>('6xl');

    const handleResize = useCallback(() => {
        setIconSize(screenUtils.isLessSm() || screenUtils.isLandscape() && screenUtils.isLessLg() ?
            '6xl' : '8xl');
    }, []);

    useEffect(() => {
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [handleResize]);

    return (
        <div className='vs-waiting-agent-response'>
            <Loader />
            <Icon name='agent-calling' size={iconSize} />
        </div>
    );
};
